/**
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file Nav.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import {
    EventTypes
} from 'starting-blocks'
import $ from 'jquery'
import TweenMax from 'TweenMax'

export default class Nav {
    /**
     * Nav Constructor
     */
    constructor (router) {
        this.router = router

        // Elements
        /**
         * @type {jQuery|HTMLElement}
         */
        this.$body = $(document.body)
        this.$cont = $('#nav')
        this.$mobileBtn = $('#mobile-nav-btn')
        this.$navTitle = this.$cont.find('.nav__title')
        this.$links = this.$cont.find('a')

        // Values
        this.navTitle = null
        this.firstInit = false
        this.pageBootResolve = null
        this.pageBootPromise = null

        // Binded methods
        this.onBeforePageLoad = this.onBeforePageLoad.bind(this)
        this.onAfterPageBoot = this.onAfterPageBoot.bind(this)
        this.onMobileBtnClick = this.onMobileBtnClick.bind(this)
    }

    init () {
        this.initEvents()
    }

    initEvents () {
        window.addEventListener(EventTypes.BEFORE_PAGE_LOAD, this.onBeforePageLoad)
        window.addEventListener(EventTypes.AFTER_PAGE_BOOT, this.onAfterPageBoot)
        this.$mobileBtn.on('click touch', this.onMobileBtnClick)
    }

    onMobileBtnClick () {
        this.$body.toggleClass('nav-open')
    }

    onBeforePageLoad () {
        this.pageBootPromise = new Promise(resolve => {
            this.pageBootResolve = resolve
        })

        Promise
            .all([this.hideNavTitle(), this.pageBootPromise])
            .then(() => {
                this.$body.removeClass('nav-open')
                this.setNavTitle()
                this.showNavTitle()
            })
    }

    /**
     * @param {DefaultPage} detail
     */
    onAfterPageBoot ({ detail }) {
        this.lazyloadVideos()
        this.navTitle = detail.navTitle

        // Remove all active class
        this.$links.removeClass('active-link')

        // get latest url
        const { url } = this.router.history.history[this.router.history.history.length - 1]

        this.$links.each((i, link) => {
            if (link.href === url) {
                $(link).addClass('active-link')
            }
        })

        if (this.pageBootResolve) {
            this.pageBootResolve()
        }

        if (!this.firstInit) {
            this.firstInit = true
            this.setNavTitle()
        }
    }

    setNavTitle () {
        this.$navTitle.html(this.navTitle)
    }

    hideNavTitle () {
        return new Promise(resolve => {
            TweenMax.to(this.$navTitle, 0.5, {
                alpha: 0,
                onComplete: resolve
            })
        })
    }

    showNavTitle () {
        return new Promise(resolve => {
            TweenMax.to(this.$navTitle, 0.5, {
                alpha: 1,
                onComplete: resolve
            })
        })
    }

    lazyloadVideos () {
        const $videos = [...$('.lazyload-video')]

        for (let video of $videos) {
            const $el = $(video)
            $el.attr('src', $el.attr('data-src'))
        }
    }
}



// WEBPACK FOOTER //
// ./webpack/js/common/Nav.js